import { render, staticRenderFns } from "./form-button-group.vue?vue&type=template&id=3288366c&scoped=true&"
import script from "./form-button-group.vue?vue&type=script&lang=js&"
export * from "./form-button-group.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3288366c",
  null
  
)

export default component.exports